import { Capacitor } from '@capacitor/core';

// Detect in-app browsers (KakaoTalk, Facebook, Instagram, etc.)
// Capacitor native app uses WebView but is not an in-app browser
export function isInAppBrowser(): boolean {
  if (Capacitor.isNativePlatform()) return false;

  const userAgent = navigator.userAgent.toLowerCase();

  return (
    userAgent.includes('kakaotalk') ||
    userAgent.includes('kakao') ||
    userAgent.includes('fban') || // Facebook
    userAgent.includes('fbav') || // Facebook
    userAgent.includes('instagram') ||
    userAgent.includes('line') ||
    (userAgent.includes('android') && userAgent.includes('wv')) // Android WebView
  );
}

export function isAndroidDevice(): boolean {
  return navigator.userAgent.toLowerCase().includes('android');
}

export function isIOSDevice(): boolean {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('iphone') || ua.includes('ipad');
}

// Get browser name for display
export function getInAppBrowserName(): string {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('kakaotalk') || userAgent.includes('kakao')) {
    return '카카오톡';
  }
  if (userAgent.includes('fban') || userAgent.includes('fbav')) {
    return '페이스북';
  }
  if (userAgent.includes('instagram')) {
    return '인스타그램';
  }
  if (userAgent.includes('line')) {
    return '라인';
  }

  return '앱 내장 브라우저';
}

// Open a URL in an external browser (Chrome on Android, instructions on iOS)
export function openInExternalBrowser(url?: string): void {
  const targetUrl = url || window.location.href;
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('android')) {
    window.location.href = `intent://${targetUrl.replace(/https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
  } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
    alert('Safari에서 열기:\n1. 우측 하단 공유 버튼 클릭\n2. "Safari에서 열기" 선택');
  }
}
